import { render, staticRenderFns } from "./ShiftSelect.vue?vue&type=template&id=13145129&lang=pug"
import script from "./ShiftSelect.vue?vue&type=script&lang=js"
export * from "./ShiftSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports